import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import useAuth from '../../Hooks/Auth'
import SignIn from './SignIn'
const Render = () => {
    const { user } = useAuth();
    if (user) {
        return <Navigate to={'/panel/' + user.type} replace />
    }
    return (
        <div className='auth'>
            <div className='col-lg-4 col-md-6'>
                <div className='title-web' style={{ marginTop: "30px" }}>
                    <p>پنل مدیریت</p>
                </div>
                <section className='section-form'>
                    <Routes>
                        <Route path='signin' element={<SignIn />} />
                        <Route
                            path='*'
                            element={<Navigate to={'/auth/signin'} replace />}
                        />
                    </Routes>
                </section>
            </div>
        </div>
    )
}

export default Render